<template>
    <data-table
        action-button-text="تازه سازی"
        action-button-icon="refresh"
        export-key="logs"
        settings-key="logs"
        @click:actionButton="getList(dataTableRef.finalFilters)"
        @getList="getList"
        ref="dataTableRef"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :getAllList="getAllList"
    >
        <template #item.ip="{value, item}">
            <img :src="detectBrowser(item.user_agent)" width="20" height="15">
            <img :src="detectOs(item.user_agent)" width="20" height="15">
            <img :key="reloadFlags" class="me-1" :src="ipCache[value]" v-if="ipCache[value] && !ipCache[value].endsWith('NON.svg')" width="20" height="15">
            {{ value }}
        </template>
    </data-table>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useAuthStore } from '@/stores/auth';
import { useSystemStore } from '@/stores/system';
import { computed } from 'vue';

defineOptions({
    title: 'لاگ درخواست ها',
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.log;
    },
})
const reloadFlags = ref(false);
const ipCache = ref([]);
const methods = [
    {id: 'GET', name: 'دریافت'},
    {id: 'POST', name: 'ایجاد'},
    {id: 'PUT', name: 'ویرایش'},
    {id: 'DELETE', name: 'حذف'}
];
const actions = [
    {id: 'announcement', name: 'اطلاعیه'},
    {id: 'branch', name: 'شعبه'},
    {id: 'calendarEvent', name: 'رویداد تقویم'},
    {id: 'customerEventType', name: 'دسته بندی رویداد'},
    {id: 'customerLevel', name: 'سطح مشتریان'},
    {id: 'customField', name: 'فیلد های سفارشی'},
    {id: 'department', name: 'دپارتمان'},
    {id: 'file', name: 'فایل پایگاه دانش'},
    {id: 'form', name: 'فرم های سفارشی'},
    {id: 'knowledgebaseArticle', name: 'مقالات پایگاه دانش'},
    {id: 'knowledgebaseCategory', name: 'دسته بندی پایگاه دانش'},
    {id: 'knowledgebaseTemplate', name: 'قالب های آماده پایگاه دانش'},
    {id: 'organization', name: 'سازمان مشتریان'},
    {id: 'service', name: 'محصولات / خدمات'},
    {id: 'sla', name: 'SLA'},
    {id: 'tag', name: 'برچسب'},
    {id: 'ticket', name: 'تیکت'},
    {id: 'ticketCategory', name: 'دسته بندی موضوعی'},
    {id: 'ticketForm', name: 'اختصاص فرم به تیکت'},
    {id: 'ticketTemplate', name: 'قالب های آماده تیکت'},
    {id: 'todo', name: 'یادداشت های شخصی'},
    {id: 'user', name: 'کاربران'},
    {id: 'workingshift', name: 'شیفت کاری'},

    {id: 'checkUsername', name: 'بررسی نام کاربری'},
    {id: 'login', name: 'لاگین'},
    {id: 'logout', name: 'خروج'},
    {id: 'me', name: 'اطلاعات کاربری'},
    {id: 'passwordReset', name: 'تغییر کلمه عبور'},
    {id: 'passwordResetToken', name: 'اعتبار سنجی'},
    {id: 'register', name: 'ثبت نام'},
    {id: 'updateChatId', name: 'ویرایش اطلاعات کاربری'},
    {id: 'updateProfile', name: 'ویرایش اطلاعات کاربری'},
    {id: 'verifyAccount', name: 'اعتبار سنجی'},

    {id: 'adminDefaults', name: 'تنظیمات اولیه کاربران'},
    {id: 'attachment', name: 'فایل پیوست'},
    {id: 'checkDefaultReciever', name: 'بررسی گیرنده پیشفرض'},
    {id: 'cities', name: 'شهر ها'},
    {id: 'callHistory', name: 'تاریخچه تماس'},
    {id: 'countries', name: 'کشور ها'},
    {id: 'customerCustomField', name: 'فیلد های سفارشی مشتریان'},
    {id: 'customerEvent', name: 'رویداد مشتریان'},
    {id: 'defaultSettings', name: 'تنظیمات اولیه'},
    {id: 'deleteTicketContent', name: 'پاسخ تیکت'},
    {id: 'deleteDoneTodos', name: 'یاداشت های شخصی'},
    {id: 'importUsers', name: 'وارد کردن گروهی کاربران'},
    {id: 'log', name: 'لاگ درخواست ها'},
    {id: 'makeCall', name: 'برقراری تماس'},
    {id: 'multipledelete', name: 'حذف گروهی'},
    {id: 'multipleTicketAction', name: 'اقدامات گروهی تیکت'},
    {id: 'order', name: 'مرتب سازی'},
    {id: 'organizationCustomField', name: 'فیلد سفارشی سازمان'},
    {id: 'satisfaction', name: 'نظر سنجی تیکت'},
    {id: 'settings', name: 'تنظیمات'},
    {id: 'states', name: 'استان ها'},
    {id: 'systemDefaults', name: 'تنظیمات اولیه سیستم'},
    {id: 'systemSettings', name: 'اطلاعات سیستم'},
    {id: 'tagAction', name: 'عملیات برچست'},
    {id: 'testEmail', name: 'تست ایمیل'},
    {id: 'testSms', name: 'تست پیامک'},
    {id: 'testWebhook', name: 'تست وب هوک'},
    {id: 'userAnnouncements', name: 'اطلاعیه ها'},
    {id: 'userNotifications', name: 'اطلاع رسانی ها'},

    {id: 'kbCategory', name: 'دسته بندی پایگاه دانش'},
    {id: 'kbArticle', name: 'مقالات پایگاه دانش'},

    {id: 'reportImportanceTicket', name: 'گزارش میزان اهمیت تیکت'},
    {id: 'reportSatisfactionEmployee', name: 'گزارش نظر سنجی کاربران سازمانی'},
    {id: 'reportSatisfactionTicket', name: 'گزارش نظر سنجی تیکت'},
    {id: 'reportServiceTicket', name: 'گزارش محصولات تیکت'},
    {id: 'reportServiceUser', name: 'گزارش کاربران و محصولات'},
    {id: 'reportSlaTicket', name: 'گزارش SLA تیکت'},
    {id: 'reportTagUserTicket', name: 'گزارش برچسب تیکت ها و مشتریان'},
    {id: 'reportTicketCategoryTicket', name: 'گزارش دسته بندی تیکت'},
    {id: 'reportTicketFrequency', name: 'گزارش فراوانی تیکت'},
    {id: 'reportTicketState', name: 'گزارش استان تیکت'},
    {id: 'reportTicketStatusTicket', name: 'گزارش وضعیت تیکت'},

    {id: 'external/customerLoginToken', name: 'توکن ورود (خارجی)'},
    {id: 'external/customerEvent', name: 'رویداد مشتریان (خارجی)'},
    {id: 'external/customerExtraInfo', name: 'اطلاعات کاربری (خارجی)'},
    {id: 'external/customers', name: 'مشتری (خارجی)'},
    {id: 'external/organizations', name: 'سازمان (خارجی)'},
    {id: 'external/kbCategories', name: 'دسته بندی پایگاه دانش (خارجی)'},
    {id: 'external/kbArticles', name: 'مقالات پایگاه دانش (خارجی)'},
    {id: 'external/satisfaction', name: 'نظر سنجی تیکت (خارجی)'},
    {id: 'external/systemDefaults', name: 'اطلاعات سیستم (خارجی)'},
    {id: 'external/tickets', name: 'تیکت (خارجی)'},
    {id: 'external/voipEvent', name: 'رویداد تماس (خارجی)'},
];
const api = useApi();
const system = useSystemStore();
const auth = useAuthStore();
const dataTableRef = useTemplateRef('dataTableRef');
const moment = useMoment();
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: 'نوع کاربر',
        key: 'role',
        value: (item) => item.user ? (item.user.employee ? 'کاربر سازمانی' : 'مشتری') : 'نامشخص',
        minWidth: 100,
    },
    {
        title: 'نام کاربر',
        key: 'user',
        value: (item) => item.user ? item.user.name : 'نامشخص',
        minWidth: 150,
    },
    {
        title: 'شعبه',
        key: 'branch',
        value: (item) => item.branch ? item.branch.name : 'نامشخص',
        minWidth: 150,
    },
    {
        title: 'پلتفرم / موقعیت',
        key: 'ip',
        value: (item) => item.ip,
        minWidth: 150,
    },
    {
        title: 'زمان',
        key: 'created_at',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.created_at ? moment(item.created_at).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
    },
    {
        title: 'عملکرد',
        key: 'method',
        value: (item) => methods.find(x => x.id == item.method).name,
        minWidth: 80,
    },
    {
        title: 'موجودیت',
        key: 'uri',
        value: (item) => actions.filter(x => item.uri.includes(x.id))?.at(-1).name ?? 'نامشخص',
        minWidth: 150,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    user_based: { type: 'divider', label: 'بر اساس کاربر', value: null },
    user_type: { type: 'radio', label: 'نوع کاربر', items: [{id: null, name: 'مشتری'}, {id: '1', name: 'کاربر سازمانی'}], onChange: () => filters.value.users.value = [], value: null, permission: auth.user.full_admin },
    branches: { type: 'autocomplete', multiple: true, label: 'شعبه', items: system.branches, value: [], permission: auth.user.full_admin },
    users: { type: false, label: 'کاربران', multiple: true, items: [{ id: auth.user.id, name: auth.user.name }, ...auth.user.to_departments.filter(x => x.users).map(x => x.users).flat().filter((value, index, self) => self.findIndex(x=> x.id == value.id) >= index)], value: [] },
    ip: { type: 'text', label: 'IP', value: null },
    performance_based: { type: 'divider', label: 'بر اساس عملکرد', value: null },
    methods: { type: 'autocomplete', multiple: true, label: 'عملکرد', items: methods, value: [] },
    action: { type: 'autocomplete', label: 'موجودیت', items: actions, value: null },
    date_based: { type: 'divider', label: 'بر اساس تاریخ', value: null },
    from_date: { type: 'date', label: 'تاریخ', dateType: 'datetime', group: 'start', onChange: (value) => { filters.value.to_date.value = value > filters.value.to_date.value ? null : filters.value.to_date.value; filters.value.to_date.min = value; }, value: null },
    to_date: { type: 'date', label: 'تاریخ', dateType: 'datetime', group: 'end', min: null, value: null },
});
filters.value.users.type = computed(() => filters.value.user_type.value == null ? 'customerSearch' : auth.user.full_admin && filters.value.user_type.value === '1' ? 'autocomplete' : false);
function detectBrowser(user_agent) {
    return user_agent.indexOf('OPR') != -1 ? '/browsers/op.svg' :
        user_agent.indexOf('Edg') != -1 ? '/browsers/me.svg' :
        user_agent.indexOf('MSIE') != -1 ? '/browsers/ie.svg' :
        user_agent.indexOf('Chrome') != -1 ? '/browsers/gc.svg' :
        user_agent.indexOf('Safari') != -1 ? '/browsers/sa.svg' :
        user_agent.indexOf('Firefox') != -1 ? '/browsers/fi.svg' :
        '/browsers/nan.svg';
}
function detectOs(user_agent) {
    return user_agent.indexOf('Win') != -1 ? '/os/mw.svg' :
        user_agent.indexOf('Android') != -1 ? '/os/an.svg' :
        /iPad|iPhone|iPod/.test(user_agent) ? '/os/io.svg' :
        user_agent.indexOf('Mac') != -1 ? '/os/mo.svg' :
        /Linux|X11/.test(user_agent) ? '/os/li.svg' :
        '/os/nan.svg';
}
function makeRequest(method, url) {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.send();
    });
}
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.getLogs(finalFilters).then(async res => {
        if (res && res.status == 'OK') {
            items.value = res.data;
            totalItems.value = res.total;
            items.value.forEach(el => {
                if(!ipCache.value[el.ip]) {
                    ipCache.value[el.ip] = '/countries/NON.svg';
                    makeRequest("GET", 'https://freeipapi.com/api/json/' + el.ip).then(res => {
                        let code = JSON.parse(res).countryCode;
                        if (code !== '-')
                            ipCache.value[el.ip] = '/countries/' + code + '.svg';
                        reloadFlags.value = !reloadFlags.value;
                    })
                }
            });
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.getLogs({
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == 'OK') {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
</script>
